import { Axios } from "utils/AxiosConfig"

export const getFavoriteCompanyForSale = async (payload) => {
  const { data: response } = await Axios.get(`member/favorite/company-for-sale`, payload)
  return response
}
export const deleteFavoriteCompanyForSale = async (id) => {
  const { data: response } = await Axios.delete(`member/favorite/company-for-sale/${id}`)
  return response
}
export const getFavoriteWantedCompany = async (payload) => {
  const { data: response } = await Axios.get(`member/favorite/buyer-profile`, payload)
  return response
}
export const deleteFavoriteWantedCompany = async (id) => {
  const { data: response } = await Axios.delete(`member/favorite/buyer-profile/${id}`)
  return response
}